import * as __WEBPACK_EXTERNAL_MODULE__sentry_react_386a9dc1__ from "@sentry/react";
import * as __WEBPACK_EXTERNAL_MODULE__utils_isString_mjs_59402478__ from "../utils/isString.mjs";
import * as __WEBPACK_EXTERNAL_MODULE__actionTransformer_mjs_cf8c453a__ from "./actionTransformer.mjs";
import * as __WEBPACK_EXTERNAL_MODULE__redactedFieldsConfig_mjs_0ac49fa1__ from "./redactedFieldsConfig.mjs";
import * as __WEBPACK_EXTERNAL_MODULE__stateTransformer_mjs_07850da9__ from "./stateTransformer.mjs";
const prepareSentryReduxEnhancerOptions = (options, additionalOptions, externalConfig)=>{
    options = {
        ...options
    };
    options.redactedFields = options.redactedFields ? {
        ...options.redactedFields
    } : {
        store: [],
        action: []
    };
    options.redactedFields.store = (options.redactedFields.store ?? []).concat(externalConfig?.redactedFields?.store ?? []).concat(additionalOptions?.redactedFields?.store ?? []).filter(__WEBPACK_EXTERNAL_MODULE__utils_isString_mjs_59402478__.isString);
    options.redactedFields.action = (options.redactedFields.action ?? []).concat(externalConfig?.redactedFields?.action ?? []).concat(additionalOptions?.redactedFields?.action ?? []).filter((it)=>(0, __WEBPACK_EXTERNAL_MODULE__utils_isString_mjs_59402478__.isString)(it) || (0, __WEBPACK_EXTERNAL_MODULE__redactedFieldsConfig_mjs_0ac49fa1__.isActionOption)(it));
    return options;
};
const createSentryReduxEnhancer = ({ maxDataLength, actionTransformer, stateTransformer, configureScopeWithState, attachReduxState = false, redactedFields })=>__WEBPACK_EXTERNAL_MODULE__sentry_react_386a9dc1__.createReduxEnhancer({
        attachReduxState,
        actionTransformer: (0, __WEBPACK_EXTERNAL_MODULE__actionTransformer_mjs_cf8c453a__.createActionTransformer)({
            redactedFields,
            actionTransformer
        }),
        stateTransformer: (0, __WEBPACK_EXTERNAL_MODULE__stateTransformer_mjs_07850da9__.createStateTransformer)({
            redactedFields,
            maxDataLength,
            stateTransformer
        }),
        configureScopeWithState
    });
const createSentryReduxEnhancer_rslib_entry_ = createSentryReduxEnhancer;
export { createSentryReduxEnhancer_rslib_entry_ as default, prepareSentryReduxEnhancerOptions };

//# sourceMappingURL=createSentryReduxEnhancer.mjs.map